import React from 'react';
import { ServerErrorPage } from '@adjust/dashboard-components';

export const ErrorPageWithDashboardCallback = props => <ServerErrorPage backUrl="/" {...props} />;
